import React from "react";
import { createPortal } from "react-dom";
import "./PageHeader.scss";
import { usePatientPageHeader } from "./PatientPageHeaderContext";

interface PageHeaderProps {
  title: string;
  eyebrow?: string;
  // Buttons or controls pinned to the right of the title, the way the records
  // page carries its refresh and upload actions.
  actions?: React.ReactNode;
  // Sits under the title, inside the topbar — plan status and similar.
  notice?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  eyebrow,
  actions,
  notice,
}) => {
  const { headerEl } = usePatientPageHeader();

  if (!headerEl) return null;

  return createPortal(
    <div className="page-header-row page-header-row--topbar">
      <div className="page-header-copy">
        {eyebrow ? <div className="page-eyebrow">{eyebrow}</div> : null}
        <h2 className="page-title">{title}</h2>
        {notice ? <div className="page-header-notice">{notice}</div> : null}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>,
    headerEl,
  );
};

export default PageHeader;
